import CookiesService from './cookies.service';
const WALLET_ACCESS_TOKEN_KEY = 'walletAccess';
const WALLET_REFRESH_TOKEN_KEY = 'walletRefresh';
class TokenService {
    getWalletRefreshToken() {
        return CookiesService.getCookie(WALLET_REFRESH_TOKEN_KEY);
    }
    getWalletAccessToken() {
        return CookiesService.getCookie(WALLET_ACCESS_TOKEN_KEY);
    }
    setWalletTokens(access, refresh) {
        CookiesService.setCookie({ key: WALLET_ACCESS_TOKEN_KEY, value: access });
        CookiesService.setCookie({ key: WALLET_REFRESH_TOKEN_KEY, value: refresh });
    }
    setTokens(access, refresh) {
        this.setWalletTokens(access, refresh);
    }
    flush() {
        CookiesService.removeCookie({ key: WALLET_ACCESS_TOKEN_KEY });
        CookiesService.removeCookie({ key: WALLET_REFRESH_TOKEN_KEY });
    }
}
export default new TokenService();
